// extracted by mini-css-extract-plugin
export default {"root":"ProtectedTooltip__root--1-oQc","tooltip":"ProtectedTooltip__tooltip--1V697","tooltipDark":"ProtectedTooltip__tooltipDark--nz0xf"};